import { ISFInfomeeting } from "../interfaces";
import {
  infomeetingTypes,
  mergeMarketData,
} from "../helpers/infomeeting-service-helpers";
import { isGatsbyProduction } from "~components/utils/env-helpers";

const SF_BASE_URL = isGatsbyProduction()
  ? "https://hsey-api.azurewebsites.net"
  : "https://hsey-api-dev.azurewebsites.net";
const HSEY_DASH_CLIENT_ID = "d10e9eb5-4670-41e9-8860-7c498b603676";
const HSEY_DASH_CLIENT_SECRET = "8b09ead6-44d5-4932-81a5-643322cc0ad6";

const WEBINAR_WEBHOOK_MAPPING: { [key: string]: string } = {
  deb: "https://wh.automate.io/webhook/60424ea91de14230a0c4a3f1",
  atv: "https://wh.automate.io/webhook/60424ea91de14230a0c4a3f1",
  chd: "https://wh.automate.io/webhook/60424ea91de14230a0c4a3f1",
  noo: "https://wh.automate.io/webhook/60424ea91de14230a0c4a3f1",
  ses: "https://wh.automate.io/webhook/60424e35b91654309ae5dca7",
  itm: "https://wh.automate.io/webhook/60424e35b91654309ae5dca7",
  nla: "https://wh.automate.io/webhook/60424e35b91654309ae5dca7",
  frp: "https://wh.automate.io/webhook/60424bf01de14230a0c4a346",
  dkc: "https://wh.automate.io/webhook/60424bf01de14230a0c4a346",
  esb: "https://wh.automate.io/webhook/60424bf01de14230a0c4a346",
};

interface IAuthSFToken {
  access_token: string;
  token_type: string;
  expires_in: number;
}

interface RegisterGoToWebinarProps {
  webinarKey: string;
  firstName: string;
  lastName: string;
  email: string;
  market: string;
}

/**
 * Gets bearer token for the SF API
 * Fetches it and stores it in the browser's session storage
 */
const getSFAuthToken = () => {
  const sfAuthTokenKey = `${
    isGatsbyProduction() ? `prod` : `dev`
  }_sf_auth_token`;
  const sfAuthToken = sessionStorage.getItem(sfAuthTokenKey);

  if (sfAuthToken) {
    return Promise.resolve(sfAuthToken);
  }

  const params: any = {
    client_id: HSEY_DASH_CLIENT_ID,
    client_secret: HSEY_DASH_CLIENT_SECRET,
    grant_type: "client_credentials",
  };

  const esc = encodeURIComponent;
  const query = Object.keys(params)
    .map((k) => esc(k) + "=" + esc(params[k]))
    .join("&");

  return fetch(`${SF_BASE_URL}/token`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: query,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json() as Promise<IAuthSFToken>;
    })
    .then((authToken) => {
      sessionStorage.setItem(sfAuthTokenKey, authToken.access_token);
      return authToken.access_token;
    });
};

/**
 * Fetches the infomeeting data for a specific SalesForce market
 */
const getSFMarket = (market: string) => {
  return getSFAuthToken().then((authToken) => {
    return fetch(
      `${SF_BASE_URL}/api/infomeetings/getAllInfomeetings?mc=${market}`,
      {
        method: "GET",
        headers: { Authorization: `bearer ${authToken}` },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response.json() as Promise<ISFInfomeeting>;
      })
      .then((sfInfomeeting) => {
        return sfInfomeeting.data;
      });
  });
};

/**
 * Fetches all infomeeting data for a specific market
 */
const getAllInfomeetingsForMarket = (
  market: string,
  meetingType: "infomeetings" | "events" = "infomeetings"
) => {
  try {
    return getSFMarket(market).then((data) => {
      const filteredData = data.filter((meeting) =>
        infomeetingTypes[meetingType].includes(meeting.meeting_Type__c)
      );
      return mergeMarketData(market, filteredData);
    });
  } catch (e) {
    return [];
  }
};

/**
 * Disable bots
 * task https://hseyit.atlassian.net/browse/MK-572
 * Register in gotowebinar directly
 * Currently hosted in automate.io
 * https://hseyit.atlassian.net/wiki/spaces/MAR/pages/1236041729/Infomeetings#Gotowebinar-integration
 */
const addGoToWebinarRegistrant = async () => {
  //props: RegisterGoToWebinarProps
  // Disable add gotowebinar
  /*const { market, webinarKey, firstName, lastName, email } = props

  if (!WEBINAR_WEBHOOK_MAPPING.hasOwnProperty(market)) {
    await Promise.resolve()
  }

  try {
    const webhookToCall = WEBINAR_WEBHOOK_MAPPING[market] ?? ''
    return await fetch(webhookToCall, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        webinarKey,
        firstName,
        lastName,
        email,
      })
    }).then(res => res.json())
  } catch (e) {
    console.log(e)
  }*/
};

export {
  getAllInfomeetingsForMarket,
  getSFAuthToken,
  addGoToWebinarRegistrant,
};
